import {
	USER_RATING_ADD_VOTE,
	USER_RATINGS_FETCH_SUCCESS,
	USER_RATING_GET_MATCH_SUCCESS,
	USER_RATING_UPDATE_REVEAL_SUCCESS,
} from '../actions/types';

const INITIAL_STATE = {
	list: {},
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case USER_RATINGS_FETCH_SUCCESS:
			return {
				...state,
				list: {
					...state.list,
					[action.id]: {
						...state.list[action.id],
						...action.payload,
					},
				},
			};
		case USER_RATING_GET_MATCH_SUCCESS:
			return {
				...state,
				list: {
					...state.list,
					[action.id]: {
						...state.list[action.id],
						...action.payload,
					},
				},
			};
		case USER_RATING_UPDATE_REVEAL_SUCCESS:
			return {
				...state,
				list: {
					...state.list,
					[action.id]: {
						...state.list[action.id],
						reveal: action.payload,
					},
				},
			};
		case USER_RATING_ADD_VOTE:
			let copyList = Object.assign({}, state.list);
			copyList[action.matchDoc] = {
				...copyList[action.matchDoc],
				[action.id]: {
					...action.payload,
				},
			};

			return {
				...state,
				list: copyList,
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/UserRatingReducer.js